import Vue from "vue";
import Vuex from "vuex";
import VueResource from "vue-resource";
import VuexPersistence from "vuex-persist";
import Cookies from "js-cookie";

import user from "@/store/_user";
import layout from "@/store/_layout";

Vue.use(VueResource);
Vue.use(Vuex);

const storageKey = "ghmGraaHz8";

// const cookieStorage = new VuexPersistence({
//   key: storageKey,
//   restoreState: (key, storage) => Cookies.getJSON(key),
//   saveState: (key, state, storage) =>
//     Cookies.set(key, state, {
//       expires: new Date(new Date().getTime() + 86400000)
//     }),
//   reducer: state => ({
//     user: {
//       username: state.user.username,
//       sessionToken: state.user.sessionToken,
//       accessRoles: state.user.accessRoles,
//       alertOn: state.user.alertOn,
//     }
//   })
// });

const localStorage = new VuexPersistence({
  key: storageKey,
  storage: window.localStorage,
  reducer: state => ({
    layout: {
      language: state.layout.language,
      sidebar: state.layout.sidebar,
      pageSize: state.layout.pageSize
    },
    user: {
      username: state.user.username,
      sessionToken: state.user.sessionToken,
      accessRoles: state.user.accessRoles,
      alertOn: state.user.alertOn,
    }
  })
});

// const sessionStorage = new VuexPersistence({
//   key: storageKey,
//   storage: window.sessionStorage,
//   reducer: state => ({
//     user: {
//       username: state.user.username,
//       sessionToken: state.user.sessionToken,
//       accessRoles: state.user.accessRoles
//     }
//   })
// });

const store = new Vuex.Store({
  modules: {
    user,
    layout
  },
  getters: {
    language: state => {
      return state.layout.language;
    },
    pageSize: state => {
      return state.layout.pageSize;
    },
    pageSizeOptions: state => {
      return state.layout.pageSizeOptions;
    },
    mfPageSize: state => {
      return state.layout.mfPageSize;
    },
    mfPageSizeOptions: state => {
      return state.layout.mfPageSizeOptions;
    },
    matchPageSize: state => {
      return state.layout.matchPageSize;
    },
    matchPageSizeOptions: state => {
      return state.layout.matchPageSizeOptions;
    },
    username: state => {
      return state.user.username;
    },
    displayName: state => {
      return state.user.username.replace(/\w\S*/g, function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
      // return state.user.username;
    },
    accessRoles: state => {
      return state.user.accessRoles;
    },
    sessionToken: state => {
      return state.user.sessionToken;
    },
    isLoggedIn: state => {
      if (state.user.sessionToken) {
        return true;
      } else {
        return false;
      }
    },
    isMinimized: state => {
      return state.layout.sidebar.minimized;
    },
    mapMatchCache: state => {
      return state.layout.mapMatchCache;
    },
    matchCache: state => {
      return state.layout.matchCache;
    },
    alertOn: state => {
      return state.user.alertOn;
    },
    get2faValidated: state => {
      return state.user.otp2faValidated;
    },
  },
  plugins: [localStorage.plugin]
  // plugins: [localStorage.plugin, cookieStorage.plugin]
  // plugins: [localStorage.plugin, sessionStorage.plugin]
});

export default store;
